import { CONFIG } from '../config/environment';
import { api } from '../lib/api';

export const fetchTrackedBookings = async (orgId?: string): Promise<any[][]> => {
  try {
    // If orgId is provided, try to fetch from database first
    if (orgId) {
      try {
        const response = await fetch(`${CONFIG.API_BASE_URL}/api/bookings/${orgId}/formatted`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          if (data.values) {
            console.log('Fetched bookings from PostgreSQL database');
            return data.values;
          }
        }
      } catch (dbError) {
        console.warn('Database fetch failed, falling back to Google Sheets', dbError);
      }
    }

    // Fallback to Google Sheets
    return await api.sheets.fetchTrackedBookings();
  } catch (error) {
    console.error('Error fetching tracked bookings:', error);
    return getMockBookingsData();
  }
};

export const fetchPayments = async (): Promise<any[][]> => {
  try {
    return await api.sheets.fetchPayments();
  } catch (error) {
    console.error('Error fetching payments:', error);
    return getMockPaymentsData();
  }
};

export const fetchUsers = async (): Promise<any[][]> => {
  try {
    return await api.sheets.fetchUsers();
  } catch (error) {
    console.error('Error fetching users:', error);
    return getMockUsersData();
  }
};

const getMockBookingsData = (): any[][] => {
  // Generate dates for the last 7 days
  const now = new Date();
  const last7Days = Array.from({ length: 7 }, (_, i) => {
    const date = new Date();
    date.setDate(now.getDate() - i);
    return date.toISOString().slice(0, 19).replace('T', ' ');
  });

  return [
    ['OrgID', 'SM Link', 'DateTime', 'Trackable Link', 'First Name', 'Last Name', 'Email', 'Closed', 'Close Amount'],
    // Recent bookings for andrewcastillo (last 7 days)
    ['andrewcastillo', 'https://www.youtube.com/watch?v=fJ9rUzIMcZQ', last7Days[0], 'https://track.link/offer1', 'John', 'Doe', 'john@email.com', 'Yes', '$299'],
    ['andrewcastillo', 'https://www.youtube.com/watch?v=fJ9rUzIMcZQ', last7Days[1], 'https://track.link/offer1', 'Jane', 'Smith', 'jane@email.com', 'Yes', '$399'],
    ['andrewcastillo', 'https://www.youtube.com/watch?v=fJ9rUzIMcZQ', last7Days[2], 'https://track.link/offer1', 'Mike', 'Wilson', 'mike@email.com', 'Yes', '$199'],
    ['andrewcastillo', 'https://www.youtube.com/watch?v=YQHsXMglC9A', last7Days[1], 'https://track.link/offer2', 'Sarah', 'Davis', 'sarah@email.com', 'No', '$0'],
    ['andrewcastillo', 'https://www.youtube.com/watch?v=8S0FDjFBj8o', last7Days[3], 'https://track.link/offer3', 'Tom', 'Anderson', 'tom@email.com', 'Yes', '$149'],
    ['andrewcastillo', 'https://www.youtube.com/watch?v=fJ9rUzIMcZQ', last7Days[4], 'https://track.link/offer1', 'Lisa', 'Taylor', 'lisa@email.com', 'Yes', '$299'],
    // Older bookings
    ['andrewcastillo', 'https://www.youtube.com/watch?v=YQHsXMglC9A', '2024-01-17 09:15:00', 'https://track.link/offer3', 'Bob', 'Johnson', 'bob@email.com', 'Yes', '$199'],
    ['andrewcastillo', 'https://facebook.com/post1', '2024-01-18 16:45:00', 'https://track.link/offer1', 'Alice', 'Brown', 'alice@email.com', 'Yes', '$399'],
    // Other users
    ['ORG001', 'https://www.youtube.com/watch?v=fJ9rUzIMcZQ', last7Days[0], 'https://track.link/offer1', 'Demo', 'User', 'demo@email.com', 'Yes', '$299'],
    ['A44366', 'https://www.youtube.com/watch?v=fJ9rUzIMcZQ', last7Days[1], 'https://track.link/offer1', 'Test', 'User', 'test@email.com', 'Yes', '$199'],
  ];
};

const getMockUsersData = (): any[][] => {
  return [
    ['UID', 'First Name', 'Email'],
    ['andrewcastillo', 'Andrew', 'andrewcastillo@example.com'],
    ['A44366', 'Andrew', 'andrew@revenuesocial.com'],
    ['ORG001', 'John', 'john@example.com'],
    ['test', 'Test', 'test@example.com'],
    ['user', 'Demo', 'demo@example.com'],
    ['demo', 'Sample', 'sample@example.com'],
  ];
};

const getMockPaymentsData = (): any[][] => {
  return [
    ['OrgID', 'SM Link', 'First Name', 'Last Name', 'Amount'],
    // Common test user IDs
    ['andrewcastillo', 'https://www.youtube.com/watch?v=fJ9rUzIMcZQ', 'John', 'Doe', '$299'],
    ['andrewcastillo', 'https://www.youtube.com/watch?v=YQHsXMglC9A', 'Alice', 'Brown', '$399'],
    ['andrewcastillo', 'https://www.youtube.com/watch?v=8S0FDjFBj8o', 'Bob', 'Johnson', '$199'],
    ['andrewcastillo', 'https://facebook.com/post1', 'Sarah', 'Davis', '$249'],
    ['andrewcastillo', 'https://instagram.com/reel1', 'Lisa', 'Taylor', '$349'],
    ['andrewcastillo', 'https://www.youtube.com/watch?v=fJ9rUzIMcZQ', 'Emma', 'White', '$299'],
    // Alternative common user IDs
    ['test', 'https://www.youtube.com/watch?v=fJ9rUzIMcZQ', 'Test', 'User', '$199'],
    ['user', 'https://www.youtube.com/watch?v=YQHsXMglC9A', 'Demo', 'User', '$299'],
    ['demo', 'https://www.youtube.com/watch?v=8S0FDjFBj8o', 'Sample', 'User', '$149'],
    // Original test data
    ['ORG001', 'https://www.youtube.com/watch?v=fJ9rUzIMcZQ', 'Original', 'Data', '$299'],
  ];
};

// Extract YouTube video ID from URL
const extractYouTubeVideoId = (url: string): string | null => {
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/watch\?.*v=([a-zA-Z0-9_-]{11})/
  ];
  
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return match[1];
  }
  return null;
};

// Get YouTube transcript from backend service
const getYouTubeTranscript = async (videoUrl: string, userId?: string): Promise<string> => {
  try {
    
    const response = await fetch(`${CONFIG.API_BASE_URL}/api/transcript`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ videoUrl, userId })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || `HTTP error! status: ${response.status}`);
    }

    return data.transcript;

  } catch (error) {
    console.error('Transcript fetch error:', error);
    
    // Provide more specific error messaging
    const errorMessage = error instanceof Error ? error.message : 'Unknown error';
    
    return `[TRANSCRIPT UNAVAILABLE: ${errorMessage}] - Using mock transcript for demo purposes. Welcome to our amazing product demo. Today I'm going to show you how our revolutionary solution can transform your business. Our product offers incredible value with features like automated workflows, real-time analytics, and seamless integrations. Many customers have seen 300% ROI within the first month. This limited-time offer includes everything you need to get started. Click the link below to secure your spot before midnight tonight. Don't miss out on this opportunity to change your business forever.`;
  }
};

// Real AI analysis using backend proxy
const analyzeWithAI = async (content: string, socialMediaLink: string, customPrompt?: string): Promise<string> => {
  try {
    return await api.ai.analyze(content, socialMediaLink, customPrompt);
  } catch (error) {
    console.error('AI analysis error:', error);
    return `Error analyzing content: ${error}`;
  }
};

export const analyzeSocialMediaLink = async (socialMediaLink: string, userId?: string, customPrompt?: string): Promise<string> => {
  try {
    // Check if it's a YouTube link
    const videoId = extractYouTubeVideoId(socialMediaLink);
    
    if (videoId) {
      const transcript = await getYouTubeTranscript(socialMediaLink, userId);
      return await analyzeWithAI(transcript, socialMediaLink, customPrompt);
    } else {
      // For non-YouTube social media, analyze the link/post
      return await analyzeWithAI(`Social media post: ${socialMediaLink}`, socialMediaLink, customPrompt);
    }
  } catch (error) {
    console.error('Analysis error:', error);
    return `Error analyzing content: ${error}`;
  }
};